import React, { useEffect } from "react";
import Styled from "styled-components";
import ramesh from "../Images/ramesh.jpg";

export default function Madhavamenoncenter() {
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  return (
    <div>
      <DIV>
        <BOX>
          <h1>Lecture on Academic Writing Skills</h1>
          <COLOR>
            <TOP>
              <p>
                The Centre organised a special lecture on ‘Academic Writing
                Skills: Do’s and Don’ts’ by Prof. (Dr.) Ramesh Laxminarayan
                Gardas, Professor, Department of Chemistry, Indian Institute of
                Technology, Madras. The session contributed to the enhancement
                of the research and academic writing skills of many research
                scholars from different disciplines from within the University
                of CUSAT as well as outside.
              </p>
            </TOP>
            <H4>Prof. (Dr) Reidar Krummradt Lie</H4>
          <img
            src={ramesh}
            alt="image"
            style={{ height: "149px", width: "164px" }}
          ></img>
          <p>
            {" "}
            Prof. Lie is a Professor of Philosophy and the Head of the
            Department of Philosophy of the University of Bergen, Norway. He is
            also an Adjunct Professor at the Institute of Basic Medical Sciences
            at the Chinese Academy of Medical Sciences, Perking Union Medical
            College, Beijing. Prof Lie is the Adjunct Senior Research Fellow at
            the Department of Bioethics of the National Institutes of Health
            (NIH), USA.{" "}
          </p>
          </COLOR>
        </BOX>
      </DIV>
    </div>
  );
}
const DIV = Styled.div`

background: #FAFAFA;
display:flex ;
justify-content:center;
align-items: center;
width:100%;
  
`;
const COLOR = Styled.div`
background:white;
padding: 20px 40px;
box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.25);
@media (max-width:368px){
  padding: 10px;
}
`;
const BOX = Styled.div`
   
    width:85%;
   
    margin:50px auto;
 h1{
    font-family: Oswald;
    font-style: normal;
    font-weight: 500;
    font-size: 32px;
    line-height: 36px;
    color: #E01E38;
    display:flex;
 }
 @media (max-width:1310px){
  h1{
    font-size: 32px;
  }
 }
 @media (max-width:660px){
  h1{
      font-size: 30px;
      }
}
@media (max-width:534px){
  margin:30px auto;
  h1{
   font-size: 28px;
   }
 }
@media (max-width:395px){
  padding: 16px;
  h1{
    font-size: 26px;
    }
}
`;

const H4 = Styled.h4`
   font-family: PT Serif;
   font-style: normal;
   font-weight: normal;
   font-size: 20px;
   line-height: 16px;
   color: #000000;
   @media (max-width:640px){
    font-size: 18px;
  }
  @media (max-width:540px){
    font-size: 16px;
  }
  @media (max-width:395px){
    font-size: 14px;
  }`;
const TOP = Styled.div`
     p{
        font-family: PT Serif;
        font-style: normal;
        font-weight: normal;
        font-size: 20px;
        line-height: 24px;
        color: #000000;
        text-align:justify;
        @media (max-width:640px){
          font-size: 18px;
        }
        @media (max-width:540px){
          font-size: 16px;
        }
      }
        span{
          font-family: PT Serif;
          font-style: normal;
          font-weight: normal;
          font-size: 20px;
          line-height: 24px;
          color: #000000;
          font-style: italic;
          display: inline-block;
          margin-top:12px;
          @media (max-width:640px){
            font-size: 18px;
          }
          @media (max-width:540px){
            font-size: 16px;
          }
        }
        }
       
     
`;
